import { HttpEvent, HttpHandlerFn, HttpRequest } from '@angular/common/http';
import { inject } from '@angular/core';
import { Observable } from 'rxjs';
import { AuthService } from '../services/auth.service';

const skipAuthUrls = [
  '/oauth2/v1/token',
  's3.amazonaws.com'
];

export function authInterceptor(req: HttpRequest<any>, next: HttpHandlerFn): Observable<HttpEvent<any>> {
  const authService = inject(AuthService);

  if (skipAuthUrls.some(url => req.url.includes(url))) {
    return next(req);
  }

  if (authService.isAuthenticated()) {
    const authReq = req.clone({
      headers: req.headers.set('Authorization', 'Bearer ' + authService.getAccessToken()),
    });
    return next(authReq);
  }
  return next(req);
}
